export default __webpack_public_path__ + "static/media/cia_logo_nav.608d6586.svg";